import { unionSchema, yup } from '@framework/validation';
import { ConditionGroupExpressionSchema } from '../../../schema/expressions/repository/condition-group/ConditionGroupExpressionSchema';
import {
  IBooleanExpressionCondition,
  IBooleanStaticCondition,
} from './IBooleanCondition';

export const StaticBooleanConditionSchema = yup
  .object({
    type: yup
      .string()
      .exact('static')
      .default('static')
      .label('Tipo di condizione')
      .required(),
    value: yup.boolean().default(true).required(),
  })
  .noUnknown();

export const ExpressionBooleanConditionSchema = yup
  .object({
    type: yup
      .string()
      .exact('expression')
      .default('expression')
      .label('Tipo di condizione')
      .required(),
    expression: ConditionGroupExpressionSchema.required(),
  })
  .noUnknown();

export const BooleanConditionSchema = unionSchema<
  IBooleanStaticCondition | IBooleanExpressionCondition
>(
  [StaticBooleanConditionSchema, ExpressionBooleanConditionSchema],
  undefined,
  schema => schema.default({ type: 'static', value: true }).nullable(),
);
